import { Star } from 'education-icons';
import { Button, Link, SimpleText, showIntlMessageNotification } from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { COMMON_NOTIFICATION_DELAY, LIBRARY_CONTENT_TYPE } from 'common.components/constants';
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { actions as lessonActions } from 'common.components/lesson';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';

import { useLocation } from 'react-router';
import { SidePanelControlTypeProps } from '../typings';

interface Props extends SidePanelControlTypeProps {
    isCopyingEnabled?: boolean;
}

export const SidePanelControlsTypeAddLessonToCourse = React.memo(
    ({ isCopyingEnabled, notifyCanBeRender, notifyCanNotBeRender }: Props) => {
        const dispatch = useDispatch();
        const { search } = useLocation();
        const canAddLessonToCourse = useSelector((storeState) =>
            lessonViewSelectors.getShouldShowCanAddLessonToCourse(storeState, { isCopyingEnabled, search })
        );
        const courseId = useSelector(getCurrentYearCourseId);

        if (!courseId || !canAddLessonToCourse) {
            notifyCanNotBeRender();
            return null;
        }

        notifyCanBeRender();

        // copy prepared lesson to own course
        const handleCopyPreparedLesson = async () => {
            if (!courseId) {
                return;
            }

            dispatch(lessonViewActions.toggleModal(false));
            dispatch(
                showIntlMessageNotification({
                    closeDelay: COMMON_NOTIFICATION_DELAY,
                    gravity: GRAVITIES.BOTTOM,
                    messageId: 'toast.lesson.lessonIsAddedToCourse',
                    theme: NOTIFICATION_THEMES.TOAST,
                })
            );

            const clessonId = await dispatch(lessonActions.addLessonToCourseAsync());
            dispatch(lessonActions.clearEditor());

            ym('reachGoal', 'teacher_lesson_creation_ready_add', {
                contentType: LIBRARY_CONTENT_TYPE.PREPARED_LESSON,
                clessonId,
            });
        };

        return (
            <Link mix="qa_copy-lesson" onClick={handleCopyPreparedLesson} pseudo>
                <Button accent={Button.ACCENT.NORMAL} icon={<Star />} view={Button.VIEW.CLEAR}>
                    <SimpleText id="lessonModal.header.copyLesson" />
                </Button>
            </Link>
        );
    }
);
